import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/screen/account/profile/index.tsx");
